// extracted by mini-css-extract-plugin
export default {"avatar":"avatar--13_wk","caller-avatar":"caller-avatar--29ERD","known-caller":"known-caller--1whh_","unknown-caller":"unknown-caller--25zFK","multiple":"multiple--RaY_v"};